
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 39 39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.25 24.375V8.125H8.071a8.125 8.125 0 000 16.25zm-13-8.125a4.854 4.854 0 014.821-4.875H13v9.75H8.071A4.854 4.854 0 013.25 16.25zM39 0v32.5c-7.863-4.888-14.358-7.3-19.5-8.125V21.1a50.444 50.444 0 0116.25 5.765V5.639A49.631 49.631 0 0119.5 11.4V8.125C24.577 7.316 30.934 5.013 39 0zM19.511 36.522a5.458 5.458 0 01-1.779-2.66l-1.87-6.219H5.874l3.1 9.56A2.6 2.6 0 0011.443 39h7.248a1.374 1.374 0 00.868-2.439zm-7.6-.772l-1.6-4.875h3.141l1.506 4.875z"}})])
          )
        }
      }
    